<template>
  <div class="container">
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t("nav.appointmentDetail") }}</h2>
      </template>
    </Toolbar>
    <div id="details">
      <Toolbar>
        <template #start>
          <h3
            id="time"
            class="my-0 p-0 mr-1"
          >
            {{ getDate(appointment.start) }} {{ $t('entity.planning.from') }}
            {{ getStartTime(appointment.start) }}
            {{ $t('entity.planning.to') }} {{ getEndTime(appointment.end) }}
          </h3>

          <span v-if="!isAgent"> - {{ $t(appointmentStatus.getDisplayKeyByStatus(appointment.status)) }}</span>
        </template>
        <template #end>
          <Button
            :label="$t('action.back')"
            class="p-button-secondary p-button-rounded p-button-outlined"
            @click="$router.go(-1)"
          />

          <template v-if="isAgent">
            <Button
              icon="pi pi-send"
              :title="$t('action.sendSummary')"
              class="p-button-info ml-2 p-button-rounded "
              @click="sendSummary"
            />

            <span class="p-inputgroup flex-1 ml-2">
              <Dropdown
                v-model="statusUpdate"
                :aria-label="$t('entity.appointment.status')"
                :options="appointmentStatus.displayStatuses"
                :option-label="(status) => $t(appointmentStatus.getDisplayKeyByStatus(status))"
              />
              <Button
                v-show="statusUpdate !== appointment.status"
                :title="$t('action.crud.update')"
                icon="pi pi-save"
                class="p-button-info"
                @click="changeStatus"
              />
            </span>
          </template>

          <Button
            v-if="isUpcoming && !isAgent && appointment.status !== appointmentStatus.CANCELED && appointment.status !== appointmentStatus.HONORED"
            icon="pi pi-times"
            :title="$t('action.cancel')"
            class="p-button-danger ml-2  p-button-rounded"
            @click="cancelDialog = true"
          />
        </template>
      </Toolbar>

      <div class="grid">
        <div class="col-12 lg:col-6">
          <div v-if="site">
            <h4 class="mb-2">
              {{ $t('entity.site.site') }}
            </h4>
            <div class="font-bold">
              <p class="mt-2">
                {{ site.name }}
              </p>
              <p class="mt-2">
                {{ site.address.name }}
              </p>
              <p class="mt-2">
                {{ site.address.postcode }} {{ site.address.city }}
              </p>
            </div>
            <div class="flex">
              <i class="pi pi-phone align-self-center" />
              <p class="ml-2">
                {{ formatPhoneNumberAsInternational(site.phoneNumber, site.phoneNumberCountryCode) }}
              </p>
            </div>
            <p class="text-justify">
              {{ $i18n.locale === 'fr' ? site.frenchDescription : site.englishDescription }}
            </p>
          </div>
          <div v-else>
            <h4 class="mb-2">
              {{ $t('entity.appointment.roamingTeam') }}
            </h4>
            <p class="m-0">
              {{ $t('entity.roamingTeam.name') }} : <strong>{{ roamingTeam.name }}</strong>
            </p>
            <h4 class="mb-2">
              {{ $t('entity.site.address.field') }}
            </h4>
            <div class="font-bold">
              <p class="mt-2">
                {{ wishedMeetingAddress.name }}
              </p>
              <p class="mt-2">
                {{ wishedMeetingAddress.postcode }} {{ wishedMeetingAddress.city }}
              </p>
            </div>
            <h4 class="mb-2">
              {{ $t('specialrequestcreatePage.sitecontact') }}
            </h4>
            <p class="mt-2">
              {{ $t('entity.user.name') }} :
              <strong>{{ specialRequestContact.firstName }} {{ specialRequestContact.lastName }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('entity.specialrequest.specialRequestContact.company') }} : <strong>{{ specialRequestContact.company }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('entity.specialrequest.specialRequestContact.profession') }} : <strong>{{ specialRequestContact.profession }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('entity.specialrequest.specialRequestContact.phoneNumber') }} :
              <strong>
                {{ formatPhoneNumberAsInternational(specialRequestContact.phoneNumber, specialRequestContact.phoneNumberCountryCode) }}
              </strong>
            </p>
            <p
              v-if="specialRequestContact.email"
              class="mt-2"
            >
              {{ $t('entity.specialrequest.specialRequestContact.email') }} : <strong>{{ specialRequestContact.email }}</strong>
            </p>
          </div>
        </div>
        <div class="col-12 lg:col-6">
          <div v-if="office">
            <h4 class="mb-2">
              {{ $t('entity.office.office') }}
            </h4>
            <p class="m-0">
              {{ $t('entity.office.name') }} : <strong>{{ office.name }}</strong>
            </p>
          </div>
          <div>
            <h4 class="mb-2">
              {{ $t('entity.user.user') }}
            </h4>
            <p class="mt-2">
              {{ $t('entity.user.name') }} : <strong>{{ user.firstname }} {{
                user.lastname
              }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('entity.user.company') }} : <strong>{{ user.stakeholder.name }}</strong>
            </p>
            <p v-if="user.email && user.email !== ''" class="mt-2">
              {{ $t('entity.user.email') }} : <strong>{{ user.email }}</strong>
            </p>
            <p
              v-if="user.phoneNumber"
              class="mt-2"
            >
              {{ $t('entity.user.phoneNumber') }} : <strong>{{ formatPhoneNumberAsInternational(user.phoneNumber, user.phoneNumberCountryCode) }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('appointmentdetailspage.equipmentNumber') }} <strong>{{
                request.amountOfEquipment
              }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('appointmentdetailspage.equipmentTaggedNumber') }} <strong>{{
                numberOfTaggedEquipments
              }}</strong>
            </p>
          </div>
          <div class="">
            <h4 class="mb-2">
              {{ $t('entity.user.stakeholderId') }}
            </h4>
            <p class="mt-2">
              {{ $t('entity.stakeholder.stakeholderId') }} : <strong>{{
                user.stakeholder.stakeholderId
              }}</strong>
            </p>
            <p class="mt-2">
              {{ $t('entity.stakeholder.name') }} : <strong>{{ user.stakeholder.name }}</strong>
            </p>
          </div>
        </div>
      </div>
      <AppointmentCancelDialog
        v-model:visible="cancelDialog"
        :appointment="appointment"
        @cancel="onUpdate"
      />
    </div>
  </div>
</template>

<script>
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";

import {convertDateStringToDayLocaleString, convertDateStringToTimeLocaleString} from "@/shared/utils/dateTimeUtils";
import moment from "moment-timezone";
import AppointmentCancelDialog from "@/components/appointments/AppointmentCancelDialog";
import {CONTACT_ROLE} from "@/shared/constants";
import useAppointmentStatus from "@/composables/useAppointmentStatus";
import Dropdown from "primevue/dropdown";
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'AppointmentDetailComponent',
  components: {AppointmentCancelDialog, Button, Toolbar, Dropdown},
  props: {
    appointment: {
      type: Object,
      required: true
    },
  },
  emits: ['update'],
  setup() {
    const appointmentStatus = useAppointmentStatus();
    return {
      appointmentStatus
    }
  },
  data() {
    return {
      cancelDialog: false,
      statusUpdate: this.appointment.status
    }
  },
  computed: {
    request() {
      return this.appointment.request
    },
    user() {
      return this.appointment.request.user
    },
    office() {
      return this.appointment.office
    },
    roamingTeam() {
      return this.appointment.roamingTeam
    },
    wishedMeetingAddress() {
      return this.appointment.wishedMeetingAddress;
    },
    specialRequestContact() {
      return this.appointment.specialRequestContact;
    },
    site() {
      return this.office ? this.office.site : null;
    },
    numberOfTaggedEquipments() {
      return this.appointment.numberOfTaggedEquipments;
    },
    isUpcoming() {
      const timezone = this.appointment.office?.site?.timezone;
      const startTz = timezone ? moment.tz(this.appointment.start, timezone) : moment(this.appointment.start);
      return startTz.isAfter(moment());
    },
    isAgent() {
      return this.$store.state.auth.user.role !== CONTACT_ROLE;
    }
  },
  methods: {
    formatPhoneNumberAsInternational,
    getDate(date) {
      return convertDateStringToDayLocaleString(date, this.$i18n.locale)
    },
    getStartTime(time) {
      return convertDateStringToTimeLocaleString(time, this.$i18n.locale)
    },
    getEndTime(time) {
      time = time.split(":")
      const date = new Date(1900, 1, 1, time[0], time[1], time[2])
      return convertDateStringToTimeLocaleString(date, this.$i18n.locale)
    },
    async changeStatus(){
      await this.$appointmentService.changeStatus(this.appointment.id, this.statusUpdate);
      this.onUpdate()
    },

    onUpdate() {
      this.$emit('update');
    },
    async sendSummary() {
      await this.$appointmentService.sendControlMail(this.appointment.id)
      this.$emitter.emit('toast', {severity: 'success', message: 'appointmentdetailspage.toast.summarySuccess'})
    }
  }
}
</script>

<style scoped lang="scss">
#time {
  text-transform: capitalize;
}

#details {
  border: 2px solid $light-grey;
  padding: 20px;
}
</style>

